module.exports = __webpack_public_path__ + "images/27df5e06757d899c03b6ee02d283af33c.svg";